var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { Grid, Box, Typography, Button, useTheme } from '@mui/material';
import get from 'lodash.get';
import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import GraphAPI from 'utilities';
import { printStartEndTime, getTimestamp, getCurrentSenior, getExactDaysDifference, formatDuration, calculatePercentageGoals, } from 'globals/global.functions';
import { Card } from 'common/components/Card';
import { ActivityChart } from './ActivityChart.component';
import { activityStyle } from './Activity.style';
import globalUseStyles from 'config/global.styles';
import { InputFields } from 'common/InputFields';
import { DIALOG_TYPES, activityGoalOptions } from 'globals/global.constants';
import ActivityCard from 'common/ActivityCard/ActivityCard.component';
import { ACTIVITY_CARD_VARIANT } from 'globals/enums';
import CircularGraph from 'common/CircularGraph/CircularGraph.component';
import { hideApplicationLoader, showApplicationLoader, } from 'common/ApplicationLoader';
import { useMutation } from 'utilities/react-query';
import { getActivityGoalService, postActivityGoalService, } from 'services/activityGoalService/activityGoal.service';
import { fetchSeniorDetail, getSeniorFullName, openOverlayDialog, showError, } from 'store/commonReducer/common.action';
import { getAuditHistory } from 'common/EditAndDisable/PauseManagement.action';
var ActivityComponent = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var _o = useAppSelector(function (state) { return state.wellnessDashboard; }), currentState = _o.currentState, startTime = _o.startTime, endTime = _o.endTime, reRender = _o.reRender;
    var daysDifference = getExactDaysDifference(startTime, endTime);
    var classes = activityStyle().classes;
    var globalClasses = globalUseStyles().classes;
    var theme = useTheme();
    var dispatch = useAppDispatch();
    var fullName = dispatch(getSeniorFullName());
    // Fetch pause status directly here instead of relying on usePauseStatus()/
    // PauseContext, since this component reads from a separate
    // `state.wellnessDashboard` slice and likely renders on its own
    // Wellness/Activity page route — outside SeniorDashboard's <PauseProvider>.
    // In that case the context silently falls back to its default
    // (never-paused) values and the Edit/Save button stays active even when
    // the profile or device is actually paused.
    var _p = useState(null), auditInfo = _p[0], setAuditInfo = _p[1];
    var isProfilePaused = (_b = (_a = auditInfo === null || auditInfo === void 0 ? void 0 : auditInfo.pauseStatus) === null || _a === void 0 ? void 0 : _a.profile) !== null && _b !== void 0 ? _b : false;
    var isDevicePaused = (_d = (_c = auditInfo === null || auditInfo === void 0 ? void 0 : auditInfo.pauseStatus) === null || _c === void 0 ? void 0 : _c.device) !== null && _d !== void 0 ? _d : false;
    var isActivityGoalDisabled = isProfilePaused || isDevicePaused;
    useEffect(function () {
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getAuditHistory())];
                    case 1:
                        info = _a.sent();
                        setAuditInfo(info);
                        return [2 /*return*/];
                }
            });
        }); };
        run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _q = useState({
        loading: true,
        subTitle: '',
        noRecordFound: false,
    }), config = _q[0], setConfig = _q[1];
    var _r = useState([]), activityChartData = _r[0], setActivityChartData = _r[1];
    var _s = useState(0), activityScore = _s[0], setActivityScore = _s[1];
    var _t = useState(0), targetScore = _t[0], setTargetScore = _t[1];
    var _u = useState(0), activityPercentage = _u[0], setActivityPercentage = _u[1];
    var _v = useState({
        moderate: 0,
        intense: 0,
        moderateGoal: 120,
        intenseGoal: 20,
        moderatePercentage: '0',
        intensePercentage: '0',
        moderateGoalTime: '2h',
        intenseGoalTime: '20m'
    }), totalDuration = _v[0], setTotalDuration = _v[1];
    var _w = useState(40000), activityGoal = _w[0], setActivityGoal = _w[1];
    var _x = useState(false), isEditActivityGoal = _x[0], setIsEditActivityGoal = _x[1];
    var getActivityGoalMutation = useMutation({
        mutationFn: function () {
            dispatch(showApplicationLoader());
            var senior = getCurrentSenior();
            return getActivityGoalService({
                senior_id: senior.seniorID,
                account_id: senior.accountID,
            });
        },
        onSuccess: function (goal) {
            setActivityGoal(goal || 40000);
            setIsEditActivityGoal(false);
            dispatch(hideApplicationLoader());
        },
        onError: function (error) {
            dispatch(hideApplicationLoader());
            dispatch(showError(error));
        },
    });
    var postActivityGoalMutation = useMutation({
        mutationFn: function (goal) {
            dispatch(showApplicationLoader());
            var senior = getCurrentSenior();
            return postActivityGoalService({
                senior_id: senior.seniorID,
                account_id: senior.accountID,
                goal: goal,
            });
        },
        onSuccess: function () {
            getActivityScore();
            getActualActivity();
            getActivityGoalMutation.mutate();
            dispatch(hideApplicationLoader());
            dispatch(openOverlayDialog({
                type: DIALOG_TYPES.SUCCESS,
                firstMessage: "Activity Goal is updated successfully for ".concat(fullName, "."),
            }));
        },
        onError: function (error) {
            dispatch(hideApplicationLoader());
            dispatch(showError(error));
        },
    });
    useEffect(function () {
        if (startTime && endTime && reRender) {
            printStartEndTime(startTime, endTime);
            setConfig(__assign(__assign({}, config), { loading: true, noRecordFound: false, subTitle: '' }));
            getActualActivity();
            getActivityScore();
            getActivityGoalMutation.mutate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startTime, endTime, reRender]);
    var getActivityScore = function () {
        GraphAPI.fetchActivityScore(startTime, endTime).then(function (res) {
            var activityScore = Math.floor(get(res, "data.".concat(startTime, ".activity_score"), 0));
            var activityPercentage = Math.round(get(res, 'goal_percentage', 0));
            setActivityScore(Math.floor(activityScore));
            setTargetScore(Math.floor(get(res, 'target_score', 0)));
            setActivityPercentage(Math.round(activityPercentage));
        });
    };
    var getActualActivity = function () {
        GraphAPI.fetchActivitySeries(startTime, endTime).then(function (res) {
            if (isEmpty(res)) {
                setConfig(__assign(__assign({}, config), { loading: false, noRecordFound: true }));
                return;
            }
            var medium = [];
            var high = [];
            var yDomain = [];
            var totalModerate = 0;
            var totalIntense = 0;
            var validDays = 0;
            Object.entries(res).forEach(function (_a) {
                var tsKey = _a[0], payload = _a[1];
                var duration = get(payload, 'activity_duration', null);
                var highActivity = get(payload, 'high_activity', 0);
                var mediumActivity = get(payload, 'medium_activity', 0);
                var xPlot = moment(getTimestamp(parseInt(tsKey, 10))).format();
                var isNull = duration === null;
                var moderateMinutes = 0;
                var intenseMinutes = 0;
                if (!isNull) {
                    moderateMinutes = (duration * (mediumActivity / 100)) / 60;
                    intenseMinutes = (duration * (highActivity / 100)) / 60;
                    totalModerate += moderateMinutes;
                    totalIntense += intenseMinutes;
                    if (duration > 0)
                        validDays++;
                    yDomain.push(moderateMinutes + intenseMinutes);
                }
                medium.push({
                    x: xPlot,
                    y: moderateMinutes,
                    isNull: isNull,
                });
                high.push({
                    x: xPlot,
                    y: intenseMinutes,
                    isNull: isNull,
                });
            });
            if (currentState === 'day')
                validDays = 1;
            setTotalDuration(function (prev) { return (__assign(__assign({}, prev), { moderate: formatDuration(totalModerate, validDays), intense: formatDuration(totalIntense, validDays), moderatePercentage: "".concat(calculatePercentageGoals(totalModerate, prev.moderateGoal * validDays)), intensePercentage: "".concat(calculatePercentageGoals(totalIntense, prev.intenseGoal * validDays)) })); });
            setConfig(__assign(__assign({}, config), { loading: false, noRecordFound: validDays === 0, maxDomain: yDomain.length ? Math.max.apply(Math, yDomain) : 0 }));
            setActivityChartData([medium, high]);
        });
    };
    var getTitle = function () {
        switch (currentState) {
            case 'day':
                return 'Goal';
            case 'week':
                return 'Week Average';
            case 'month':
                return 'Month Average';
        }
    };
    var handleSetActivityGoal = React.useCallback(function () {
        if (isActivityGoalDisabled)
            return;
        postActivityGoalMutation.mutate(activityGoal);
    }, [activityGoal, postActivityGoalMutation, isActivityGoalDisabled]);
    var handleActivityGoalButtonClick = React.useCallback(function () {
        if (isActivityGoalDisabled)
            return;
        if (isEditActivityGoal) {
            handleSetActivityGoal();
        }
        else {
            setIsEditActivityGoal(true);
        }
    }, [isActivityGoalDisabled, isEditActivityGoal, handleSetActivityGoal]);
    useEffect(function () {
        dispatch(fetchSeniorDetail());
    }, []);
    return (_jsxs(Grid, { spacing: 2, container: true, "data-testid": 'activity-container', children: [_jsxs(Grid, { item: true, xs: 12, sm: 12, md: 4.5, flexDirection: 'column', container: true, spacing: 2, children: [_jsx(Grid, { item: true, children: _jsx(Card, { isLoading: config.loading, cardContentStyle: {
                                padding: '5px 16px 8px 16px',
                            }, children: _jsxs(Box, { display: 'flex', flexWrap: 'wrap', style: {
                                    justifyContent: 'space-between',
                                    gap: '1rem',
                                    width: '100%',
                                }, children: [_jsxs(Box, { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '1rem', children: [_jsx(Typography, { className: classes.activityGoalLabel, children: "Set Activity Goal" }), _jsx(Box, { width: '140px', children: _jsx(InputFields, { menu: true, inputProps: {
                                                        name: 'activity_goal',
                                                        disabled: !isEditActivityGoal || isActivityGoalDisabled,
                                                    }, menuItems: activityGoalOptions, eventProps: {
                                                        onChange: function (e) { return setActivityGoal(e.target.value); },
                                                        value: activityGoal,
                                                        'data-testid': 'activity-goal-input',
                                                    } }) })] }), _jsx(Button, { variant: 'contained', color: 'primary', className: globalClasses.smallButton, style: { minWidth: '120px' }, disabled: isActivityGoalDisabled, onClick: handleActivityGoalButtonClick, "data-testid": 'activity-goal-button', children: isEditActivityGoal ? 'Save' : 'Edit' })] }) }) }), _jsx(Grid, { item: true, children: _jsx(Card, { isLoading: config.loading, noRecordFound: config.noRecordFound, title: getTitle(), stretch: true, cardContentStyle: { overflow: 'hidden' }, children: _jsxs(Box, { display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem', width: '100%', children: [_jsx(Box
                                    // width='220px'
                                    , { 
                                        // width='220px'
                                        width: '175px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0, children: _jsx(Box, { width: '175px', height: '175px', children: _jsx(CircularGraph, { data: [
                                                    {
                                                        value: totalDuration.intensePercentage,
                                                        color: (_f = (_e = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _e === void 0 ? void 0 : _e.customColor) === null || _f === void 0 ? void 0 : _f.intenseGreen,
                                                        key: 'intense',
                                                    },
                                                    {
                                                        value: totalDuration.moderatePercentage,
                                                        color: (_h = (_g = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _g === void 0 ? void 0 : _g.customColor) === null || _h === void 0 ? void 0 : _h.moderateGreen,
                                                        key: 'moderate',
                                                    },
                                                    {
                                                        value: activityPercentage,
                                                        color: (_k = (_j = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _j === void 0 ? void 0 : _j.customColor) === null || _k === void 0 ? void 0 : _k.remGreen,
                                                        key: 'score',
                                                    },
                                                ], bgColor: (_m = (_l = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _l === void 0 ? void 0 : _l.customColor) === null || _m === void 0 ? void 0 : _m.bgGrey }) }) }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '1rem', flexGrow: 1, minWidth: 0, children: [_jsx(ActivityCard, { variant: ACTIVITY_CARD_VARIANT.ACTIVITY, goal: "".concat(activityScore, "/").concat(targetScore), percentage: activityPercentage }), _jsx(ActivityCard, { variant: ACTIVITY_CARD_VARIANT.MODERATE, goal: "".concat(totalDuration.moderate || '0h', "/").concat(totalDuration.moderateGoalTime), percentage: totalDuration.moderatePercentage }), _jsx(ActivityCard, { variant: ACTIVITY_CARD_VARIANT.INTENSE, goal: "".concat(totalDuration.intense || '0m', "/").concat(totalDuration.intenseGoalTime), percentage: totalDuration.intensePercentage })] })] }) }) })] }), _jsx(Grid, { item: true, xs: 12, sm: 12, md: 7.5, children: _jsx(Card, { noRecordFound: config.noRecordFound, isLoading: config.loading, title: 'Activity', stretch: true, children: _jsx(ActivityChart, { type: currentState, activityChartData: activityChartData, currentState: currentState, maxDomain: config.maxDomain }) }) })] }));
};
export { ActivityComponent };
